export const badgeIds = [
  'trainedInGrimroot',
  'magicInstrumentCollector',
  'escapedBandits',
  'escapedWaterSpirit',
] as const;
